<template>
  <div class="content">
    <div class="days-forecast">
      <div class="publish-time" v-if="showTime && giftData.ddatetime">
        <!--        数据时间：{{ $moment(giftData.ptimestemp).format('YYYY-MM-DD HH:mm') }}-->
        <!-- <div>{{ giftData.ddatetime }}更新</div> -->
      </div>
      <div class="days-forecast-list">
        <div
          class="item"
          v-for="(item, index) in giftData.mint"
          :key="index"
          v-show="index < 3"
        >
          <span>{{ giftData.date[index] }}</span>
          <img
            :src="
              require(
                `@/assets/images/weatherIcon_p/${giftData.icon[index]}.png`,
              )
            "
          />
          <span class="desc">{{ giftData.desc[index] }}</span>
          <span>{{ giftData.mint[index] }}℃ - {{ giftData.maxt[index] }}℃</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
export default {
  // props: ['params', 'forecastType'],
  props: {
    forecastType: {
      type: Number,
      default: 0,
    },
    showTime: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      giftData: {},
    };
  },
  watch: {
    activeCountyId: {
      handler() {
        setTimeout(() => {
          this.getGiftData();
        }, 100);
      },
      immediate: true,
    },
    forecastType() {
      this.resetEchart();
    },
    sevenDayDataResult: {
      handler() {
        this.$nextTick(() => {
          this.getGiftData();
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", ["objsList", "activeCountyId", "sevenDayDataResult"]),
  },
  mounted() {
    this.$bus.$on("changeForest", (data) => {
      this.getGiftData();
    });
  },
  methods: {
    initEchart() {
      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = (document.body.clientWidth / 1920) * 16;
        document.getElementsByTagName("html")[0].style.fontSize =
          this.$rootFontSize + "px";
      };
    },
    // 获取gif预报
    async getGiftData(data) {
      try {
        const result =
          data || JSON.parse(JSON.stringify(this.sevenDayDataResult));
        if (!result || !result.data) {
          return;
        }
        // console.log('当前选中点位', this.activeCountyId)
        // 根据点位所在区获取对应的位置预报
        const index = this.objsList.findIndex(
          (item) => item.id === this.activeCountyId,
        );
        const county = this.objsList[index].county.replace("区", "");
        console.log("county", county);
        const countyResult = result.data[county] || {};
        // const date = result.data[county].datetime
        // countyResult.icon = countyResult.icon.map(v => String(v).padStart(2, '0'))
        // const dateStr = this.$moment(date).format('YYYY-MM-DD HH:mm')
        // countyResult.datetime = dateStr
        this.giftData = countyResult;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.26vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .hour-forecast {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .hour-forecast-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      height: 100%;
      overflow: hidden;

      .hour-forecast-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #fff;
          }

          .des {
            font-size: 0.88rem;
            color: #fff;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #fff;
          }
        }

        #temp-chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .desc {
      }

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 6.85rem;
        height: 9rem;
        span {
          font-size: 0.85rem;
          color: #fff;
        }

        font {
          font-size: 0.98rem;
          color: #fff;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 53%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: 0.8vw;
    color: #fff;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
